var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconAdjust48Line = function SvgIconAdjust48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.1 29.9c0-1.08-.56-2.03-1.4-2.59V11h-3.4v16.31c-.84.55-1.4 1.5-1.4 2.59a3.1 3.1 0 0 0 1.4 2.59V37h3.4v-4.51a3.1 3.1 0 0 0 1.4-2.59ZM25.7 15.51V11h-3.4v4.51a3.1 3.1 0 0 0-1.4 2.59c0 1.08.56 2.03 1.4 2.59V37h3.4V20.69c.84-.55 1.4-1.5 1.4-2.59a3.1 3.1 0 0 0-1.4-2.59ZM15.7 24.41V11h-3.4v13.41A3.1 3.1 0 0 0 10.9 27c0 1.08.56 2.03 1.4 2.59V37h3.4v-7.41c.84-.55 1.4-1.5 1.4-2.59a3.1 3.1 0 0 0-1.4-2.59Z",
    fill: "current"
  })));
};
export default SvgIconAdjust48Line;